import script from "./Trial.vue?vue&type=script&setup=true&lang=js"
export * from "./Trial.vue?vue&type=script&setup=true&lang=js"

import "./Trial.vue?vue&type=style&index=0&id=1e926227&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e926227"]])

export default __exports__